const modalBulkConfirmationMessageId = 'msync-modal-member-bulk-confirmation-message'
const modalBulkActionsId = {
  members: {
    demoteToMember: {
      title:  'Demote to Member',
      request: 'msync_bulk_member_set_as_member',
      content: 'Demoting the selected user(s) from manager to member will remove their management capabilities. They will no longer be able to invite or remove other users.'  
    },
    setAsManager: {
      title: 'Set as Manager',
      request: 'msync_bulk_member_set_as_manager',
      content: "Are you sure you'd like to apply management permissions to the selected user(s)? Managers can add and remove users. Confirm your choice to proceed."
    },
    deleteUser: {
      title: 'Delete User',
      request: 'msync_bulk_member_delete_user',
      content: 'Are you sure you want to delete the selected user(s)? This action cannot be undone, and all associated data will be permanently removed.'
    } 
  },
  pendingInvites: {
    setAsManager: {
      action: 'invitation_set_as_manager',
      title: 'Set as Manager',
      request: 'msync_bulk_pending_invite_set_as_manager',
      content: "Set the selected user(s) from member to manager user will have the management permissions. Managers can add and remove users. Confirm your choice to proceed."
    },
    setAsMember: {
      action: 'invitation_set_as_member',
      title:  'Set as Member',
      request: 'msync_bulk_pending_invite_set_as_member',
      content: 'Set the selected user(s) from manager to member user will remove their management capabilities. They will no longer be able to invite or remove other users.  Confirm your choice to proceed.'  
    },
    resendInvitation: {
      action: 'invitation_resend',
      title: 'Resend',
      request: 'msync_bulk_pending_invite_resend',
      content: 'Are you sure you want to resend the invitation to the selected user(s)? They will be notified again. Confirm your choice to proceed.'
    },
    revokeInvitation: {
      action: 'invitation_revoke',
      title: 'Revoke',
      request: 'msync_bulk_pending_invite_revoke',
      content: 'Are you sure you want to cancel the invitation sent to the selected user(s)? This action cannot be undone and the user will not be automatically notified of the cancellation. Confirm your choice to proceed.'
    }
  }
}

export {
  modalBulkActionsId,
  modalBulkConfirmationMessageId
}
